import { Type } from 'class-transformer';
import { BaseResidentParameterDto } from '../../_models/base-resident-parameter-dto';

export class AccParameterDto extends BaseResidentParameterDto {
  open: boolean = true; //Defaults to True
  @Type(() => Date)
  beginDate: Date;
  @Type(() => Date)
  endDate: Date;

  constructor(customerId?: string, communityId?: number) {
    super(customerId, communityId);
  }

  override getQueryString(): string {
    return `?customerId=${this.customerId}&communityId=${this.communityId}&open=${this.open}&clearCache=${this.clearCache}`;
  }
}
